const jwtServiceConfig = {
  getToken: '/core/get-token',
  refreshToke: '/core/refresh-token',
  getClients: '/core/get-clients',
  getAuthorizationCode: '',
  revokeToken: ''
};

export default jwtServiceConfig;
